import React, { useEffect, useState } from "react";

import InfoSection from "../trackshipment/infoSection";
import { useParams } from "react-router-dom";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../config/firebase";
import { toast } from "react-toastify";
import { Steps } from "antd";
import { FormatDate } from "../../lib/dateFormat";
import axios from "axios";

const items = [
  "Collection",
  "Compliance",
  "In Transit",
  "Custom Clearance",
  "Final Delivery",
  "Delivered",
];

const TrackingLink = () => {
  const obj = {
    active: true,
    content: "Shipments Tracking",
  };

  const [shipment, setShipment] = useState({});
  const [expandedComment, setExpandedComment] = useState(null);
  const { id } = useParams();
  // console.log(id)
  useEffect(() => {
/*     const fetchShipment = async () => {
      try {
        const ref = collection(db, "quotes");
        const q = query(ref, where("trackingNumber", "==", id));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          // If there are documents in the query snapshot
          // Take the first document (assuming there's only one)
          const data = querySnapshot.docs[0].data();
          setShipment(data);
        } else {
          toast.error("Quote data not found");
        }
      } catch (error) {
        console.error("Error fetching Quote data:", error);
        toast.error("Error fetching Quote data");
      }
    }; */
    const fetchShipment = async () => {
  try {
    const res = await axios.get(`/api/tracking/trackshipment/${id}`);
    setShipment(res.data.data);
  } catch (error) {
    console.error(error);
    toast.error("Shipment not found");
  }
};

    if (id) {
      fetchShipment();
    }
  }, [id]);
  // console.log(shipment)
  return (
    <div>
      <div className="flex bg-cus-gray ">
        {/* Main content */}
        <div className="md:w-4/5 w-full mx-auto">
          <div className="p-4 space-y-5  min-h-screen">
            {/* Info section */}
            <div className="flex justify-between gap-3 md:flex-row flex-col items-start">
              <div className="w-full bg-white trackingRounded">
                <InfoSection />
              </div>
            </div>
            {/* Shipment details */}
            <div className="w-full mt-5 ">
              <div className="bg-white trackingRounded pb-10 w-full ">
                {/* Shipment header */}
                <div className="bg-[#509268] text-lg font-medium text-white py-4 px-4 rounded-tr-2xl rounded-tl-2xl ">
                  Shipment Details : {shipment.orderNumber}
                </div>
                {/* Shipment content */}
                <div className="py-5 md:px-16 w-full mx-auto  px-5 ">
                  <Steps
                    current={(() => {
                      const subStatus = shipment.orderDetails?.subStatus;
                      const status = shipment.status;
                      if (
                        status?.toLowerCase() === "completed" ||
                        status?.toLowerCase() === "delivered" ||
                        subStatus?.toLowerCase() === "delivered" ||
                        subStatus?.toLowerCase() === "completed"
                      ) {
                        return items.length - 1;
                      }
                      const subIdx = items.findIndex(
                        (item) => item.toLowerCase() === subStatus?.toLowerCase()
                      );
                      if (subIdx !== -1) return subIdx;
                      const statusIdx = items.findIndex(
                        (item) => item.toLowerCase() === status?.toLowerCase()
                      );
                      if (statusIdx !== -1) return statusIdx;
                      return 0;
                    })()}
                    items={items?.map((item) => ({ title: item }))}
                  />
                </div>
                <div className=" w-full flex-wrap mx-auto p-4 md:px-16  px-5 ">
                  <div className="flex  justify-between md:flex-row flex-col items-start w-full ">
                    <div className="md:w-2/5 w-full  ">
                      <h2 className="text-black text-lg font-semibold">
                        1: Pick up date :{" "}
                        {FormatDate(shipment.loadAddress_PickUpDate)}
                      </h2>
                      <div className="flex gap-4 items-center justify-between ">
                        <p className="w-1/2">Company Name: </p>
                        <p className="w-1/2 text-gray-700 text-sm">
                          {shipment.loadAddress_CompanyName}
                        </p>
                      </div>
                      <div className="flex gap-4 items-center justify-between">
                        <p className="w-1/2">Pickup Time:</p>
                        <p className="w-1/2 text-gray-700 text-sm">
                          {shipment.loadAddress_PickUpTime &&
                            `       ${shipment.loadAddress_PickUpTime?.startTime} -   ${shipment.loadAddress_PickUpTime?.endTime}`}
                        </p>
                      </div>

                      <div className="flex gap-4 items-start justify-between">
                        <p className="w-1/2">load Address:</p>
                        <p className="w-1/2 text-gray-700 text-sm">
                          {shipment.loadAddress}, {shipment.loadCountry} ,{" "}
                          {shipment.loadAddressPostalCode}
                        </p>
                      </div>

                      <div className="flex gap-4 items-center justify-between ">
                        <p className="w-1/2">Customer Reference: </p>
                        <p className="w-1/2 text-gray-700 text-sm">
                          {shipment.loadAddress_ReferenceCustomer}
                        </p>
                      </div>

                      <div className="flex flex-col sm:flex-row gap-4 items-start">
      <p className="w-full sm:w-1/2 font-semibold">Comments:</p>
      <div className="w-full sm:w-1/2 text-gray-700 text-sm">
        <div className="break-words overflow-hidden">
          {expandedComment === "load"
            ? shipment.loadAddress_Comments
            : (shipment.loadAddress_Comments?.split(" ").slice(0, 20).join(" ") || "") +
              (shipment.loadAddress_Comments?.split(" ").length > 20 ? "..." : "")}
        </div>
        {shipment.loadAddress_Comments?.split(" ").length > 20 && (
          <button
            className="text-blue-500 hover:text-blue-700 mt-1 text-sm font-medium focus:outline-none"
            onClick={() =>
              setExpandedComment(expandedComment === "load" ? null : "load")
            }
          >
            {expandedComment === "load" ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </div>
                    </div>
                    <div className="md:w-2/5 w-full">
                      <h2 className="text-black text-lg font-semibold">
                        2: Delivery date :{" "}
                        {FormatDate(shipment.unloadAddress_DeliveryDate)}
                      </h2>
                      <div className="flex gap-4 items-center justify-between ">
                        <p className="w-1/2">Company Name: </p>
                        <p className="w-1/2 text-gray-700 text-sm">
                          {shipment?.unloadAddress_CompanyName}
                        </p>
                      </div>
                      <div className="flex gap-4 items-center justify-between">
                        <p className="w-1/2">Delivery Time:</p>
                        <p className="w-1/2 text-gray-700 text-sm">
                          {shipment.unloadAddress_DeliveryTime &&
                            `       ${shipment.unloadAddress_DeliveryTime?.startTime} -   ${shipment.unloadAddress_DeliveryTime?.endTime}`}
                        </p>
                      </div>

                      <div className="flex gap-4 items-start ">
                        <p className="w-1/2">unload Address:</p>
                        <p className="w-1/2 text-gray-700 text-sm">
                          {shipment.unloadAddress}, {shipment.unloadCountry} ,{" "}
                          {shipment.unloadPostalCode}
                        </p>
                      </div>
                      <div className="flex gap-4 items-center ">
                        <p className="w-1/2">Customer Reference:</p>
                        <p className="w-1/2 text-gray-700 text-sm">
                          {shipment.unloadAddress_ReferenceCustomer}
                        </p>
                      </div>

                      <div className="flex flex-col sm:flex-row gap-4 items-start">
      <p className="w-full sm:w-1/2 font-semibold">Comments:</p>
      <div className="w-full sm:w-1/2 text-gray-700 text-sm">
        <div className="break-words overflow-hidden">
          {expandedComment === "load"
            ? shipment.unloadAddress_Comments
            : (shipment.unloadAddress_Comments?.split(" ").slice(0, 20).join(" ") || "") +
              (shipment.unloadAddress_Comments?.split(" ").length > 20 ? "..." : "")}
        </div>
        {shipment.unloadAddress_Comments?.split(" ").length > 20 && (
          <button
            className="text-blue-500 hover:text-blue-700 mt-1 text-sm font-medium focus:outline-none"
            onClick={() =>
              setExpandedComment(expandedComment === "load" ? null : "load")
            }
          >
            {expandedComment === "load" ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingLink;
